import { render, staticRenderFns } from "./AppReceipt.vue?vue&type=template&id=07b440d4&scoped=true&"
import script from "./AppReceipt.vue?vue&type=script&lang=js&"
export * from "./AppReceipt.vue?vue&type=script&lang=js&"
import style0 from "./AppReceipt.vue?vue&type=style&index=0&id=07b440d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b440d4",
  null
  
)

export default component.exports